import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { CVCompetenceTypesService } from "../../core/cvcompetencetypes.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import * as modes from "./modes";

@Component({
    selector: "crew-edit-cvcompetencetype",
    template: require('./cv-competence-type.edit.component.html')
})
export class EditCvCompetenceType extends EditBase<Nema.Crew.Model.CompetenceTypeCVMapping> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('cvCompetenceType') cvCompetenceTypeEntity: Nema.Crew.Model.CompetenceTypeCVMapping,
        @Inject("cvCompetenceGroups") public cvCompetenceGroups: Nema.Crew.Model.CVCompetenceGroup[],
        @Inject("competenceGroups") public competenceGroups: Nema.Crew.Model.CompetenceGroup[],
        @Inject("competenceTypes") public competenceTypes: Nema.Crew.Model.CompetenceType[],
        @Inject(CVCompetenceTypesService.Id) private cvCompetenceTypeDataService: CVCompetenceTypesService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, cvCompetenceTypeEntity, cvCompetenceTypeDataService, $log, isNew);

        if (!isNew) {
            (<any>this.entity.CompetenceTypeCVMappingCompetenceGroups).load();
            (<any>this.entity.CompetenceTypeCVMappingCompetenceTypes).load();
        }
    }

    public entityDisplayName = "CV Competence";

    public listStateName = "app.settings.cvcompetencetypes";

    public namingModes = modes.namingModes;

    public inclusionModes = modes.inclusionModes;

    public addCompetenceGroupMapping(): void {
        var newMapping = this.cvCompetenceTypeDataService.newCompetenceGroupMapping(this.competenceGroups[0].Id);
        this.entity.CompetenceTypeCVMappingCompetenceGroups.push(<any>newMapping);
    }

    public removeCompetenceGroupMapping(mapping: Nema.Crew.Model.CompetenceTypeCVMappingCompetenceGroup) {
        var index = this.entity.CompetenceTypeCVMappingCompetenceGroups.indexOf(mapping, 0);
        if (index > -1) {
            var mappingToDelete = this.entity.CompetenceTypeCVMappingCompetenceGroups[index];
            this.cvCompetenceTypeDataService.removeMapping(mappingToDelete, () => this.entity.CompetenceTypeCVMappingCompetenceGroups.splice(index, 1));
        }
    }

    public addCompetenceTypeMapping(): void {
        var newMapping = this.cvCompetenceTypeDataService.newCompetenceTypeMapping(this.competenceTypes[0].Id);
        this.entity.CompetenceTypeCVMappingCompetenceTypes.push(<any>newMapping);
    }

    public removeCompetenceTypeMapping(mapping: Nema.Crew.Model.CompetenceTypeCVMappingCompetenceType) {
        var index = this.entity.CompetenceTypeCVMappingCompetenceTypes.indexOf(mapping, 0);
        if (index > -1) {
            var mappingToDelete = this.entity.CompetenceTypeCVMappingCompetenceTypes[index];
            this.cvCompetenceTypeDataService.removeMapping(mappingToDelete, () => this.entity.CompetenceTypeCVMappingCompetenceTypes.splice(index, 1));
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencetypes/cv-competence-type.edit.component.ts